import { render, staticRenderFns } from "./YSelectArea.vue?vue&type=template&id=96ba5376"
import script from "./YSelectArea.vue?vue&type=script&lang=js"
export * from "./YSelectArea.vue?vue&type=script&lang=js"
import style0 from "./YSelectArea.vue?vue&type=style&index=0&id=96ba5376&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports